import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    margin-bottom: 20px;
`;

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.interfaceGray200 || '#E5E7EB'};
    background-color: ${({ theme }) => theme.colors.interfacePure0 || '#FFFFFF'};
    animation: slideDown 0.2s ease-out;

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

export const SelectContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    width: 100%;
`;

export const Label = styled.label`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.interfaceText300 || '#9CA3AF'};
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
    flex-shrink: 0;
`;

export const SelectWrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const SelectTrigger = styled.button<{ isOpen: boolean }>`
    width: 100%;
    height: auto;
    padding: 8px 12px;
    border: 1px solid ${({ theme }) => theme.colors.interfaceText200 || '#E5E7EB'};
    border-radius: 6px;
    background: ${({ theme }) => theme.colors.interfacePure0 || '#FFFFFF'};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.2s ease;
    text-align: left;
    gap: 8px;

    &:hover {
        border-color: ${({ theme }) => theme.colors.interfaceText300 || '#D1D5DB'};
    }

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
        box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primaryRed400 || '#E52940'}20;
    }
`;

export const SelectValue = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
`;

export const SelectValueName = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.interfaceText400 || '#6B7280'};
    white-space: nowrap;
`;

export const SelectValueBadge = styled.span<{ variant: 'correspondente' | 'solicitante' }>`
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 6px;
    background: ${({ variant, theme }) => 
        variant === 'correspondente' 
            ? theme.colors.interfacePure100 || '#F3F4F6'
            : 'transparent'};
    color: ${({ theme }) => theme.colors.interfaceText400 || '#6B7280'};
    border: 1px solid ${({ theme }) => theme.colors.interfaceText200 || '#E5E7EB'};
    white-space: nowrap;
    font-weight: 500;
`;

export const SelectDropdown = styled.div<{ isOpen: boolean }>`
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    background: ${({ theme }) => theme.colors.interfacePure0 || '#FFFFFF'};
    border: 1px solid ${({ theme }) => theme.colors.interfaceText100 || '#F3F4F6'};
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;
    display: ${({ isOpen }) => isOpen ? 'block' : 'none'};
    width: 100%;
`;

export const SelectItem = styled.button`
    width: 100%;
    padding: 12px 16px;
    border: none;
    background: transparent;
    cursor: pointer;
    text-align: left;
    transition: background 0.2s ease;
    display: flex;
    flex-direction: column;
    gap: 4px;

    &:hover {
        background: ${({ theme }) => theme.colors.interfacePure100 || '#F3F4F6'};
    }

    &:first-child {
        border-radius: 6px 6px 0 0;
    }

    &:last-child {
        border-radius: 0 0 6px 6px;
    }
`;

export const SelectItemRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    
    svg {
        flex-shrink: 0;
    }
`;

export const SelectItemName = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.interfaceText400 || '#6B7280'};
`;

export const SelectItemBadge = styled.span<{ variant: 'correspondente' | 'solicitante' }>`
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 6px;
    background: ${({ variant, theme }) => 
        variant === 'correspondente' 
            ? theme.colors.interfacePure100 || '#F3F4F6'
            : 'transparent'};
    color: ${({ theme }) => theme.colors.interfaceText400 || '#6B7280'};
    border: 1px solid ${({ theme }) => theme.colors.interfaceText200 || '#E5E7EB'};
    font-weight: 500;
`;

export const SelectItemEmail = styled.span`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.interfaceText300 || '#9CA3AF'};
    font-weight: 400;
`;

export const SelectOverlay = styled.div<{ isOpen: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    display: ${({ isOpen }) => isOpen ? 'block' : 'none'};
`;


export const TextareaStyled = styled.textarea`
    width: 100%;
    min-height: 120px;
    max-height: 300px;
    padding: 12px;
    border: 1px solid ${({ theme }) => theme.colors.interfaceGray300 || '#D1D5DB'};
    border-radius: 6px;
    font-size: 14px;
    font-family: inherit;
    line-height: 1.5;
    resize: none;
    overflow-y: auto;
    color: ${({ theme }) => theme.colors.interfaceText600 || '#374151'};
    background-color: ${(props: any) => props.theme.colors.interfacePure0};

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
        box-shadow: 0 0 0 3px rgba(229, 41, 64, 0.1);
    }

    &::placeholder {
        color: ${({ theme }) => theme.colors.interfaceGray400 || '#9CA3AF'};
    }
    
    &:focus-visible {
        outline: none;
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 8px;
`;

export const ButtonStyled = styled.button<{ variant?: 'outline' | 'default' }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    min-height: 40px;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
    transform: scale(1);

    ${props => props.variant === 'outline' ? `
        background-color: ${(props: any) => props.theme.colors.interfacePure0};
        color: ${props.theme.colors.interfaceText600 || '#374151'};
        border: 1px solid ${props.theme.colors.interfaceGray300 || '#D1D5DB'};

        &:hover:not(:disabled) {
            background-color: ${props.theme.colors.interfacePure100 || '#F2F2F2'};
            border-color: ${props.theme.colors.interfaceGray300 || '#D1D5DB'};
            transform: scale(1.02);
        }
    ` : `
        background-color: ${props.theme.colors.primaryRed400 || '#E52940'};
        color: ${(props: any) => props.theme.colors.pureWhite};

        &:hover:not(:disabled) {
            background-color: ${props.theme.colors.primaryRed500 || '#C91E32'};
            transform: scale(1.02);
        }
    `}

    &:active:not(:disabled) {
        transform: scale(0.98);
    }

    &:focus {
        outline: 2px solid ${props => props.variant === 'outline' ? props.theme.colors.interfaceGray400 : props.theme.colors.primaryRed400};
        outline-offset: 2px;
    }

    &:disabled {
        background: ${({theme}) => theme.colors.disabledBg};
        border-color: ${({theme}) => theme.colors.disabledBg};
        color: ${({theme}) => theme.colors.disabledText};
        cursor: not-allowed;
        opacity: 0.6;
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

